<template>
  <div id="app">
    <NavBar />
    <router-view class="main-content"></router-view>
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from './components/Footer.vue'
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    SiteFooter,
    NavBar
  }
}
</script>

<style>
#app {
  font-family: 'Inter', 'Noto Sans SC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1 0 auto;
}
</style>
